export default __webpack_public_path__ + "static/media/izuna.760601d2.png";